import React from 'react';

const colorLabels = {
  opinion: 'red',
  idea: 'yellow',
  musings: 'blue',
};

const defaultColor = 'red';

const colorForLabel = (label) => {
  const supportedLabels = Object.keys(colorLabels);
  if (supportedLabels.includes(label)) {
    return colorLabels[label];
  }
  return defaultColor;
}

const ArticleLabel = ({label, color}) => (
  <div className={`Article-labels-item Article-labels-item--${color}`}>
    {label}
  </div>
);

export default class ArticleLabels extends React.Component {
  renderLabels() {
    return this.props.labels.map((label, index) => <ArticleLabel key={`label-${index}`} label={label} color={colorForLabel(label)} />);
  }
  render() {
    return(
      <div className="Article-labels">
        {
          this.renderLabels()
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/article/articleLabel/index.js